<template>
  <div class="body">
    <div class="detay">
      <div class="sayfabaslik">
        <div class="text">
          <div class="el-button-group">

            <router-link tag="el-button" class="el-button--small" active-class="el-button--primary"
                         to="/muhasebe/tahakkuk" type="default">Mesken Borçlandır
            </router-link>
            <router-link tag="el-button" class="el-button--small" active-class="el-button--primary"
                         to="/muhasebe/gider" type="default">Gider İşle
            </router-link>
            <router-link tag="el-button" class="el-button--small" active-class="el-button--primary"
                         to="/muhasebe/gelir" type="default">Gelir İşle
            </router-link>
            <router-link tag="el-button" class="el-button--small" active-class="el-button--primary"
                         to="/muhasebe/cari" type="default">Cari
            </router-link>
            <router-link tag="el-button" class="el-button--small" active-class="el-button--primary"
                         to="/muhasebe/personel" type="default">Personel
            </router-link>
            <router-link v-if="$store.getters.Paket!=2" tag="el-button" class="el-button--small"
                         active-class="el-button--primary"
                         to="/muhasebe/fatura" type="default">Şirket Fatura
            </router-link>
            <router-link tag="el-button" class="el-button--small" active-class="el-button--primary"
                         to="/muhasebe/kasa" type="default">Kasa
            </router-link>
            <router-link tag="el-button" class="el-button--small" active-class="el-button--primary"
                         to="/muhasebe/kategori" type="default">Kategori
            </router-link>
            <router-link tag="el-button" class="el-button--small" active-class="el-button--primary"
                         to="/muhasebe/meskenturu" type="default">Mesken Türü
            </router-link>

          </div>
        </div>
        <div class="el-button-group btn-group float-right" v-if="this.$store.state.Sayfa.MenuDisplay">
          <router-link tag="el-button" class="el-button--small el-button--info"
                       v-for="Menu in this.$store.state.Sayfa.Menu" :to="Menu.Link">{{ Menu.Adi }}
          </router-link>
        </div>
      </div>

      <router-view></router-view>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
  created() {
    if (this.$store.getters.Yetki.muhasebe == '0') this.$router.push("/403");
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Muhasebe/_route.vue